<script setup>
    import { pages } from '#nuxt-prepare'

    const route = useRoute()
    //const entry = pages[route.params.slug]

    const entry = await useStatamic().getEntry('pages', route.params.slug)

    useHead({
        title: (() => {
            if (entry?.title && entry.title != 'Home') {
                return entry.title
            }

            return null
        })(),
    })
</script>

<template>
    <SetPageBannerText :title="entry.title" :text="entry.page_banner_text" />

    <div v-if="entry">
        <template v-for="section in entry.content">
            <SetText v-if="section.type === 'text'" :fields="section" />
            <SetFeatureImage v-if="section.type === 'feature_image'" :fields="section" />
        </template>
    </div>

    <div v-else class="text-center">
        <h1 class="mb-2 text-brand2">Page not found</h1>
        <p>The page you requested couldn't be found.</p>
        <p>
            <NuxtLink to="/" class="text-brand1 underline hover:no-underline">
                Return to the home page
            </NuxtLink>
        </p>
    </div>
</template>
